<template>
  <div class="container">
    <div class="topContainer">
      <el-form size="small" :model="form" style="width: 87%;" ref="refForm" :rules="rules" label-width="180px">
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{ $t('deliveryGoods.deliveryInformation') }}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="12">
            <el-form-item :label="$t('common.shipmentNumber') + ':'" prop="no">
              <el-input
                v-model.trim="form.no"
                name="shipmentNumber"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="255"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="12">
            <el-form-item :label="$t('common.deliveryCheckReport') + ':'" prop="deliveryCheckReport">
              <el-upload
                :headers="headers"
                :action="actionDeliveryCheckReport"
                :on-success="handleSuccessDeliveryCheckReport"
                :on-remove="handleRemoveDeliveryCheckReport"
                :before-upload="handleBeforeUpload"
                :on-error="handleError"
                :on-preview="handlerPreviewDeliveryCheckReport"
                :on-exceed="handlerExceedDeliveryCheckReport"
                :limit="1"
                :file-list="fileListDeliveryCheckReport"
                accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF">
                <el-button size="small" type="plain">{{ $t('common.upload') }}</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.customerInformation')}}{{form.c}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="12">
            <el-form-item :label="$t('common.customerName') + ':'" prop="customerId">
              <el-select
                :value="customerVal"
                clearable
                filterable
                style="width: 100%;"
                size="small"
                @change="changeCustomer">
                <el-option
                  v-for="item in customersList"
                  :key="item.id"
                  :label="item.customerName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('common.contact') + ':'" prop="contact">
              <el-input
                v-model.trim="form.contact"
                name="contact"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="16">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="12">
            <el-form-item :label="$t('common.contactPhone') + ':'" prop="contactPhone">
              <el-input
                v-model.trim="form.contactPhone"
                name="contactPhone"
                type="tel"
                autocomplete="on"
                clearable
                size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('common.address') + ':'" prop="contactAddr">
              <el-input
                v-model.trim="form.contactAddr"
                name="contactAddr"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="24">
            <el-form-item :label="$t('common.comment') + ':'">
              <el-input
                v-model="form.comment"
                name="comment"
                type="textarea"
                autocomplete="on"
                clearable
                size="small"
                maxlength="255"
                :rows="3"
                show-word-limit>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{ $t('common.deliveryDevice') + '/' + $t('common.component')}}</h4>
        </el-form-item>
      </el-form>
      <div class="target-container">
        <el-tabs v-model="activeName">
          <el-tab-pane :label="$t('common.device')" name="device"></el-tab-pane>
          <el-tab-pane :label="$t('common.component')" name="component"></el-tab-pane>
        </el-tabs>
        <el-table
          v-show="activeName === 'device'"
          ref="table"
          border
          max-height="400"
          :data="deviceList"
          :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
          :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
          header-cell-class-name="headerCellName"
          row-key="id"
          default-expand-all>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-table
                max-height="100%"
                border
                :data="scope.row.subDevice"
                :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
                :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
                header-cell-class-name="headerCellName"
                row-key="id">
                <el-table-column prop="addr" :label="$t('common.address')"/>
                <el-table-column prop="deviceName" :label="$t('common.componentName')"/>
                <el-table-column prop="deviceModel" :label="$t('common.componentModel')"/>
                <el-table-column prop="deviceNo" :label="$t('common.componentNumber')"/>
                <el-table-column prop="productionDate" :label="$t('common.productionDate')">
                  <template slot-scope="scope">
                    {{ formatDate(scope.row.productionDate) }}
                  </template>
                </el-table-column>
                <el-table-column prop="softwareVersion" :label="$t('common.softwareVersion')"/>
                <el-table-column prop="deviceSerialNo" :label="$t('common.componentSerialNo')"/>
                <el-table-column prop="status" :label="$t('common.status')">
                  <template slot-scope="scope">
                    {{ subDeviceStatusVal(scope.row) }}
                  </template>
                </el-table-column>
                <el-table-column prop="num" :label="$t('common.count')">
                  <template slot-scope="scope">
                    {{ scope.row.num | toThousandFilter }}
                  </template>
                </el-table-column>
                <el-table-column prop="unit" :label="$t('common.unit')">
                </el-table-column>
                <el-table-column prop="comment" :label="$t('common.comment')" show-overflow-tooltip>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.deviceCategory')">
            <template slot-scope="scope">
              {{ deviceCategoryVal(scope.row.flag) }}
            </template>
          </el-table-column>
          <el-table-column prop="addr" :label="$t('common.address')"/>
          <el-table-column prop="deviceName" :label="$t('common.deviceName')"/>
          <el-table-column prop="deviceModel" :label="$t('common.deviceModel')"/>
          <el-table-column prop="deviceNo" :label="$t('common.deviceNumber')"/>
          <el-table-column prop="productionDate" :label="$t('common.productionDate')">
            <template slot-scope="scope">
              {{ formatDate(scope.row.productionDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="installationDate" :label="$t('common.installDate')">
            <template slot-scope="scope">
              {{ formatDate(scope.row.installationDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="softwareVersion" :label="$t('common.softwareVersion')"/>
          <el-table-column :label="$t('common.status')">
            <template slot-scope="scope">
              {{ deviceStatusVal(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="num" :label="$t('common.count')">
            <template slot-scope="scope">
              {{ scope.row.num | toThousandFilter }}
            </template>
          </el-table-column>
          <el-table-column prop="unit" :label="$t('common.unit')">
          </el-table-column>
          <el-table-column prop="comment" :label="$t('common.comment')" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <el-table
          v-show="activeName === 'component'"
          max-height="400"
          border
          :data="subDeviceList"
          :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
          :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
          header-cell-class-name="headerCellName"
          row-key="id">
          <el-table-column prop="addr" :label="$t('common.address')"/>
          <el-table-column prop="deviceName" :label="$t('common.componentName')"/>
          <el-table-column prop="deviceModel" :label="$t('common.componentModel')"/>
          <el-table-column prop="deviceNo" :label="$t('common.componentNumber')"/>
          <el-table-column prop="productionDate" :label="$t('common.productionDate')">
            <template slot-scope="scope">
              {{ formatDate(scope.row.productionDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="softwareVersion" :label="$t('common.softwareVersion')"/>
          <el-table-column prop="deviceSerialNo" :label="$t('common.componentSerialNo')"/>
          <el-table-column prop="status" :label="$t('common.status')">
            <template slot-scope="scope">
              {{ subDeviceStatusVal(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="num" :label="$t('common.count')">
            <template slot-scope="scope">
              {{ scope.row.num | toThousandFilter }}
            </template>
          </el-table-column>
          <el-table-column prop="unit" :label="$t('common.unit')">
          </el-table-column>
          <el-table-column prop="comment" :label="$t('common.comment')" show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="control-container">
      <div>
        <el-button :loading="loading" type="danger" size="mini" @click="deleteDeviceDelivery">
          {{ $t('common.delete') }}
        </el-button>
        <router-link :to='{path: `/delivery-list/${deliveryId}`}' tag="a" target="_blank" style="margin: 0 10px;">
          <el-button type="warning" size="small">
            {{$t('common.print')}}
          </el-button>
        </router-link>
        <el-button :loading="loading" size="small" type="primary" @click="submitForm">
          {{ $t('common.update') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {
  deviceDeliveryUpdate,
  deviceDeliveryDelete,
  deviceDeliveryList,
} from '@/api/device';
import {
  Pagination,
} from '@/components';
import {
  defaultCategoryTypes,
  defaultDeviceStatus,
  defaultSubDeviceStatus,
} from '@/utils/defines';
import {mapGetters} from "vuex";
import {isValueEmpty} from "@/utils";
import i18n from "@/lang";
import {validateContactPhone} from "@/utils/validate";
import {customersList} from "@/api/customers";

const defaultForm = {
  no: undefined,
  deliveryCheckReport: undefined,
  comment: undefined,
  customerId: undefined,
  customerName: undefined,
  contact: undefined,
  contactPhone: undefined,
  contactAddr: undefined,
};

const categoryTypes = {
  ...defaultCategoryTypes,
  100: {
    val: 100,
    explain: i18n.t('common.component'),
  }
};

export default {
  name: "detail",
  components: {
    Pagination,
  },
  data() {
    return {
      form: {...defaultForm, no: this.createNo()},
      rules: {
        no: [{required: true, trigger: 'change', message: this.$t('device.shipmentNumberCanNotBeEmpty')}],
        deviceIds: [{required: true, trigger: 'change', message: this.$t('device.deviceCanNotBeEmpty')}],
        customerId: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.customerNameCanNotBeEmpty') }],
        contact: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.contactCanNotBeEmpty') }],
        contactPhone: [{ required: true, trigger: 'blur', validator: validateContactPhone }],
        contactAddr: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.contactCanNotBeEmpty') }],
      },
      deviceList: [],
      fileListDeliveryCheckReport: [],
      loading: false,
      deliveryId: undefined,
      tempRoute: {},
      activeName: 'device',
      subDeviceList: [],
      customersList: [],
    };
  },
  computed: {
    ...mapGetters([
      'token',
    ]),
    headers() {
      return {
        Authorization: `Bearer ${this.token}`,
      };
    },
    actionDeliveryCheckReport() {
      return '/api/v1/files/deliveryCheckReport';
    },
    customerVal() {
      const {
        customerId,
        customerName,
      } = this.form;
      const findIndex = this.customersList.findIndex(item => item.id === customerId);
      if (findIndex !== -1) {
        return customerId;
      }
      return customerName;
    },
  },
  mounted() {
    this.deliveryId = this.$route.params && this.$route.params.deliveryId;
    this.deviceDeliveryDetail();
    this.tempRoute = Object.assign({}, this.$route);
    this.customersListGet(1, 2000);
  },
  methods: {
    async deviceDeliveryDetail() {
      try {
        const res = await deviceDeliveryList({
          id: this.deliveryId,
        });
        const {data} = res;
        const deliverys = data.records || [];
        if (deliverys.length === 0) {
          this.$message({
            type: 'error',
            message: this.$t('device.deviceDeliveryInfoMissing'),
          });
          return;
        }
        const {
          no,
          deliveryCheckReport,
          comment,
          customerId,
          customer,
          contact,
          contactPhone,
          contactAddr,
          devicesHistories,
        } = deliverys[0];
        let deliveryCheckReportVal;
        if (deliveryCheckReport) {
          try {
            deliveryCheckReportVal = JSON.parse(deliveryCheckReport);
            this.fileListDeliveryCheckReport = [];
            for (let row of deliveryCheckReportVal) {
              this.fileListDeliveryCheckReport.push({
                name: row,
                url: this.attachmentUrl(row, 'deliveryCheckReport'),
              });
            }
          } catch (e) {
            // do nothing.
          }
        }
        if (devicesHistories) {
          let linkedSubDeviceListObj = {};
          this.deviceList = [];
          this.subDeviceList = [];
          let parentDevId;
          for (let row of devicesHistories) {
            if (row) {
              if (row.flag === 100) {
                parentDevId = row.parentDevId;
                if (parentDevId === null) {
                  this.subDeviceList.push(row);
                } else {
                  if (!linkedSubDeviceListObj[parentDevId]) {
                    linkedSubDeviceListObj[parentDevId] = [];
                  }
                  linkedSubDeviceListObj[parentDevId].push(row);
                }
              } else {
                this.deviceList.push(row)
              }
            }
          }
          for (let row of this.deviceList) {
            row.subDevice = linkedSubDeviceListObj[String(row.deviceId)] || [];
          }
        }
        this.form = {
          no,
          deliveryCheckReport: deliveryCheckReportVal,
          comment,
          customerId,
          customerName: customer && customer.customerName,
          contact,
          contactPhone,
          contactAddr,
        };
      } catch (e) {
        // do nothing.
      }
    },
    deleteDeviceDelivery() {
      this.$confirm(this.$t('device.thisActionWillDeleteThisDeviceDelivery'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        this.loading = true;
        try {
          await deviceDeliveryDelete({
            id: this.deliveryId,
          });
          this.$message({
            type: 'success',
            message: this.$t('common.deleteSuccess'),
          });
          this.backDeviceDeliveryListPage();
        } catch (e) {
        } finally {
          this.loading = false;
        }
      }).catch(() => {
        // do nothing.
      });
    },
    handleBeforeUpload(file) {
      const isLessThan2M = file.size / 1024 / 1024 < 2;
      if (!isLessThan2M) {
        this.$message({
          type: 'error',
          message: this.$t('common.sizeNotExceed2M'),
        });
      }
      return isLessThan2M;
    },
    handleError() {
      this.$message({
        type: 'error',
        message: this.$t('common.uploadFailure'),
      });
    },
    handleSuccessDeliveryCheckReport(response, file) {
      this.form.deliveryCheckReport = [file.name];
      this.$message({
        type: 'success',
        message: this.$t('common.uploadSuccess'),
      });
    },
    handleRemoveDeliveryCheckReport() {
      this.form.deliveryCheckReport = undefined;
    },
    handlerPreviewDeliveryCheckReport(file) {
      const url = this.attachmentUrl(file.name, 'deliveryCheckReport');
      window.open(url, 'blank');
    },
    handlerExceedDeliveryCheckReport() {
      this.$message({
        type: 'error',
        message: this.$t('device.aDeviceDeliveryCanOnlyHaveAtMostOneDeliveryCheckReport'),
      });
    },
    attachmentUrl(attachment, file) {
      return `${window.location.protocol}//${window.location.hostname}:${window.location.port}/${file}/${attachment}`;
    },
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          this.deviceDeliveryUpdate();
        }
      });
    },
    async deviceDeliveryUpdate() {
      const {
        no,
        deliveryCheckReport,
        customerId,
        contact,
        contactPhone,
        contactAddr,
        comment,
      } = this.form;
      this.loading = true;
      try {
        await deviceDeliveryUpdate({
          id: this.deliveryId,
          no: no,
          deliveryCheckReport: deliveryCheckReport && deliveryCheckReport.length > 0 ? JSON.stringify(deliveryCheckReport) : null,
          customerId,
          contact,
          contactPhone,
          contactAddr,
          comment: isValueEmpty(comment) ? undefined : comment,
        });
        this.$message({
          type: 'success',
          message: this.$t('common.updateSuccess'),
        });
        this.backDeviceDeliveryListPage();
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    createNo() {
      let str = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789';
      let n = 4;
      let s = '';
      let rand = '';
      let length = str.length;
      for (let i = 0; i < n; i++) {
        rand = Math.floor(Math.random() * length);
        s += str.charAt(rand);
      }
      return 'NT' + moment().format('YYMM') + s;
    },
    backDeviceDeliveryListPage() {
      this.$router.replace({path: '/asset-management/deviceDelivery'});
      this.$store.dispatch('tagsView/delView', this.tempRoute);
    },
    deviceCategoryVal(flag) {
      return categoryTypes[flag] ? `${categoryTypes[flag].explain}` : ''
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      return updateDate.local().format('YYYY/MM/DD');
    },
    deviceStatusVal(row) {
      const {
        status,
      } = row;
      const deviceStatus = defaultDeviceStatus[String(status)];
      return deviceStatus ? deviceStatus.explain : status;
    },
    subDeviceStatusVal(row) {
      const {
        status,
      } = row;
      const subDeviceStatus = defaultSubDeviceStatus[String(status)];
      return subDeviceStatus ? subDeviceStatus.explain : status;
    },
    async customersListGet(page, perpage) {
      try {
        const res = await customersList({ page, perpage, });
        const { data } = res;
        this.customersList = data.records;
      } catch (e) {
        // do nothing.
      }
    },
    changeCustomer(val) {
      if (val) {
        for (const row of this.customersList) {
          if (row.id === val) {
            this.form.customerId = row.id;
            this.form.contact = row.contact;
            this.form.customerName = row.contactName;
            this.form.contactPhone = row.contactPhone;
            this.form.contactAddr = row.contactAddr;
            this.$refs.refForm.validateField(['customerId', 'contact', 'contactPhone', 'contactAddr']);
            break;
          }
        }
      }
    },
  }
}
</script>

<style scoped>
.container {
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}

.control-container {
  background: #F5F5F5;
  padding: 20px;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: center;
}
.topContainer {
  height: 100%;
  overflow: auto;
  flex: 1;
}
.el-form {
  padding: 10px 20px 0;
}
.el-form-item {
  margin-bottom: 10px;
}
.target-container {
  margin: 0 20px 0;
}
</style>
<style>
.headerCellName {
  background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
  background: -o-linear-gradient(#F9F9F9, #EEEEEE);
  background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
  background: linear-gradient(#F9F9F9, #EEEEEE);
}
.small_label .el-form-item__label {
  font-size: 12px;
}
</style>
